import clsx from "clsx";
import React from "react";
import IComponentProps from "../common/component-props";
import styles from "./tabs.module.scss";

export enum SettingsTab {
  Account = 0,
  EnterpriseUser = 1,
  Invitation = 2
}

const settingsTabDictionary = {
  [SettingsTab.Account]: "Account",
  [SettingsTab.EnterpriseUser]: "Users",
  [SettingsTab.Invitation]: "Invitations",
}

export interface ITab {
  title?: string;
  isActive?: boolean;
  tabType: SettingsTab;
  isVisible: boolean;
}

export interface ITabsProps extends IComponentProps {
  tabs: ITab[];
  onActivate: (tab: ITab) => void;
}

export function Tabs(props: ITabsProps) {

  return (
    <div className={clsx(styles.root, props.className)} data-testid={props.testId || "tabs"}>
      {props.tabs
          .filter(tab => !!tab.isVisible)
          .map((tab, index) => (
            <div key={index} className={clsx(styles.tab, tab.isActive && styles["tab--active"])} data-testid="tab" onClick={() => props.onActivate(tab)}>
              <h3>{
                !!tab.title
                  ? tab.title
                  : settingsTabDictionary[tab.tabType]
              }</h3>
            </div>
          ))}
    </div>

  );
}